import { Injectable } from '@angular/core';

/**
 * Holds the Turnstile token the captcha component just earned until the
 * credential request that needs it goes out. The API checks the token on that
 * request itself, so it is handed over once and then forgotten: Turnstile
 * tokens are single use.
 */
@Injectable({ providedIn: 'root' })
export class CaptchaTokenStore {
  private token: string | null = null;

  set(token: string): void {
    this.token = token;
  }

  /** The pending token, cleared as it is taken. Null when there is none. */
  take(): string | null {
    const token = this.token;
    this.token = null;
    return token;
  }
}
